import {createAction} from "redux-act";

export const setViewedRoundID = createAction<number | null>();